import Scene, { ISceneParams } from './Scene';
import Game from '../Game';
import LevelSystem from '../System/Level/LevelSystem';
import CardSystem from '../System/Card/CardSystem';
import RenderSystem from '../System/Render/RenderSystem';
import AnimationSystem from '../System/Animation/AnimationSystem';
import LevelUISystem from '../System/UI/LevelUISystem';
import TimerSystem from '../System/Timer/TimerSystem';
import AudioSystem from "System/Audio/AudioSystem";

export interface ILevelSceneParams extends ISceneParams {
    levelNumber: number;
}

export default class LevelScene extends Scene {
    public params: ILevelSceneParams;

    public init(): void {
        console.log('Level Scene beginning init');
        this.addSystem(new TimerSystem(Game.store));
        this.addSystem(new LevelSystem(Game.store, this.params.levelNumber));
        this.addSystem(new CardSystem(Game.store));
        this.addSystem(new LevelUISystem(Game.store));
        this.addSystem(new AnimationSystem(Game.store));
        this.addSystem(new RenderSystem(Game.store));
        this.addSystem(new AudioSystem(Game.store));

        this.systems.forEach(system => system.init());
    }
}
